import { render, staticRenderFns } from "./ListTableBodyRow.vue?vue&type=template&id=ffa2815a&scoped=true&"
import script from "./ListTableBodyRow.vue?vue&type=script&lang=js&"
export * from "./ListTableBodyRow.vue?vue&type=script&lang=js&"
import style0 from "./ListTableBodyRow.vue?vue&type=style&index=0&id=ffa2815a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa2815a",
  null
  
)

export default component.exports